import React from 'react';
import {
  getClassNameFactory,
  Heading,
  Sizes,
  Typography,
  TextBoldness,
  Link,
  Responsive,
} from '@dcl/ui';
import { ISupportHoursHeader } from '../../SupportHoursTypes';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  NORMAL_HOURS_TEXT,
  PH_NUMBER_TEXT,
} from '../../constants';

export const SupportHoursHeader: React.FC<ISupportHoursHeader> = (props) => {
  const {
    productTitle,
    normalHours,
    phNumber,
    pageTitle,
    pageDescription,
  } = props;

  const getClassName = getClassNameFactory(SupportHoursHeader.displayName);

  return (
    <div className={getClassName()}>
      <Heading
        type={types.Large}
        boldType={boldTypes.medium}
        data-testid="test-title"
        className={getClassName({
          descendantName: 'title',
        })}
      >
        {productTitle}
      </Heading>

      <Responsive minWidth={DESKTOP_MIN_WIDTH}>
        <div
          className={getClassName({
            descendantName: 'subtitle',
          })}
        >
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Medium}
            className={getClassName({
              descendantName: 'label',
            })}
          >
            {NORMAL_HOURS_TEXT}
          </Typography>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Medium}
            className={getClassName({
              descendantName: 'value',
            })}
          >
            {PH_NUMBER_TEXT}
          </Typography>
        </div>
        <div
          className={getClassName({
            descendantName: 'subtitle',
          })}
        >
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Regular}
            className={getClassName({
              descendantName: 'label',
            })}
          >
            {normalHours}
          </Typography>
          <div
            className={getClassName({
              descendantName: 'value',
            })}
          >
            <Link href={`tel:${phNumber}`} type={LinkTypes.INLINE}>
              {phNumber}
            </Link>
          </div>
        </div>
      </Responsive>

      <Responsive minWidth={0} maxWidth={MOBILE_MAX_WIDTH}>
        <div>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Medium}
            className={getClassName({
              descendantName: 'label`',
            })}
          >
            {NORMAL_HOURS_TEXT}
          </Typography>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Regular}
            className={getClassName({
              descendantName: 'value',
            })}
          >
            {normalHours}
          </Typography>
        </div>
        <div>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            boldness={TextBoldness.Medium}
            className={getClassName({
              descendantName: 'label',
            })}
          >
            {PH_NUMBER_TEXT}
          </Typography>
          <div
            className={getClassName({
              descendantName: 'value',
            })}
          >
            <Link href={`tel:${phNumber}`} type={LinkTypes.INLINE}>
              {phNumber}
            </Link>
          </div>
        </div>
      </Responsive>

      <div
        className={getClassName({
          descendantName: 'tableHeading',
        })}
      >
        <Heading
          type={types.Medium}
          boldType={boldTypes.medium}
          className={getClassName({
            descendantName: 'tableTitle',
          })}
        >
          {pageTitle}
        </Heading>

        <div
          className={getClassName({
            descendantName: 'tableDescp',
          })}
        >
          <Typography type={Sizes.XXTRASMALL} tag={TypographyTags.P}>
            {pageDescription}
          </Typography>
        </div>
      </div>
    </div>
  );
};

SupportHoursHeader.displayName = 'SupportHoursHeader';
